import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const TimerItem = ({ data }) => {
    const payload = data.payload;
    const task = payload.task;
    const value = payload.value || '';

    return (
        <ListItem>
            <i className="material-icons">timer</i>
            <ListItemText primary={task.name} secondary={`Tempo decorrido: ${value}`} />
        </ListItem>
    );

}

export default TimerItem;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/Timer.js